import React from 'react';
import { Table } from 'reactstrap';

class SimpleTable extends React.Component {
  render() {
    return (
      <Table {...this.props} hover>
        <thead>
          <tr className="text-capitalize align-middle text-center">
            {!this.props.noCounts && <th>#</th>}
            {this.props.columns.map((column, index) => (
              <th
                key={index}
                style={
                  this.props.onColumnClick
                    ? {
                        cursor: 'pointer',
                        backgroundColor:
                          this.props.highlightedColumn === column ? 'grey' : '',
                      }
                    : {}
                }
                onClick={() => {
                  if (this.props.onColumnClick) {
                    this.props.onColumnClick(column);
                  }
                }}
              >
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {this.props.rows.map((row, rowIndex) => (
            <tr
              style={this.props.onRowClick ? { cursor: 'pointer' } : {}}
              key={rowIndex}
              className="align-middle text-center"
              onClick={() => {
                if (this.props.onRowClick) {
                  this.props.onRowClick(row);
                }
              }}
            >
              {!this.props.noCounts && <th scope="row">{1 + rowIndex}</th>}
              {this.props.keys.map((key, colIndex) => (
                <td className="align-middle text-center" key={colIndex}>
                  {this.props.keyIndexes && this.props.keyIndexes[colIndex]
                    ? row[key][this.props.keyIndexes[colIndex]]
                    : row[key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
}
export default SimpleTable;
